import set from 'lodash/set';

import { getAuthenticatedFetchRaw } from './fetch';

export const fetchPdcAttachment = (injectedFetch = fetch, attachmentUrl) => {
    const configuredFetch = getAuthenticatedFetchRaw(injectedFetch);

    return configuredFetch(attachmentUrl, set({})).then((response) => response.json());
};
